import { useEffect, useState } from "react";
import { InputProps } from "./Input";
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

export default function DateInput(props: InputProps) {

    const [value, setValue] = useState<Date | undefined>(props.value ? new Date(props.value): undefined);

    const makeShownValue = () => {
        return value? value.getDate() + " / " + (value.getMonth() + 1) + " / " + value.getFullYear() : '-- / -- / ----'
    }

    const [shownValue, setShownValue] = useState<string>(makeShownValue())
    const [showCalendar, setShowCalendar] = useState(false);

    useEffect(() => {
        props.onChange(value);
        setShownValue(makeShownValue())
    }, [value])
    
    return (<div>
        <label>{props.content.title} </label> 
        <input type="text" value={shownValue} onClick={() => {
            setShowCalendar(!showCalendar);
        }} readOnly></input>
        {showCalendar && <Calendar onChange={(val) => {
            if(val as Date) {
                setValue(val as Date);
            } else {
                setValue(undefined);
            }
            setShowCalendar(false);
        }} value={value}></Calendar>}
    </div>)
}